module.exports = __webpack_public_path__ + "static/img/doc-bp.0c24994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About-pics/doc-bp.jpg
// module id = 4zFl
// module chunks = 0